module.exports = __webpack_public_path__ + "img/barber_shop-400x300.142a7782.jpg";